var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2921 15H1.70776C2.12587 10.7889 5.67884 7.5 9.99996 7.5C14.3211 7.5 17.874 10.7889 18.2921 15Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 8.33335L4.16669 5.41669",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.33335L15.4167 5.41669",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25002 12.9167C6.71026 12.9167 7.08335 12.5436 7.08335 12.0833C7.08335 11.6231 6.71026 11.25 6.25002 11.25C5.78978 11.25 5.41669 11.6231 5.41669 12.0833C5.41669 12.5436 5.78978 12.9167 6.25002 12.9167Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.9167C14.2103 12.9167 14.5834 12.5436 14.5834 12.0833C14.5834 11.6231 14.2103 11.25 13.75 11.25C13.2898 11.25 12.9167 11.6231 12.9167 12.0833C12.9167 12.5436 13.2898 12.9167 13.75 12.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.1c17df8bf60eda7fb2dcbd8c95eab22e.svg";
export { ForwardRef as ReactComponent };